export default "__VITE_ASSET__D4bvPuN5__"